module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-textarea', {
    attrs: {
      "label": "Instructions Document"
    },
    model: {
      value: (_vm.instructions),
      callback: function($$v) {
        _vm.instructions = $$v
      },
      expression: "instructions"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "success": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveInstructions()
      }
    }
  }, [_vm._v("Save")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-36853a82"}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/ReturnShopPortalsInstructionsDocument.vue
// module id = 931
// module chunks = 1